<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="mute_delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <b-button @click="mute_remove" variant="primary">{{ $t('simple.delete') }}</b-button>
            
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    export default {

        mounted: function () {
            console.log('Mute List Remove Modal mounted');
        },

        destroyed() {
            console.log('Mute List Remove Modal destroyed.');
        },

        data: function() {
             return  {}
        },

        methods: {

            mute_remove: async function() { 

                // Loading start
                this.$wait.start('mute_delete');

                // Delete mute
                await axios.delete('/api/v1/twitter/mutes/' + this.id, { user_id: this.user_id})
                .then((response) => {

                    // Show success
                    Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                    // Loading stop
                    this.$wait.end('mute_delete');

                    // Close modal
                    this.$close(true);
                    //console.log(response);

                })
                .catch((error) => {
                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // Loading stop
                    this.$wait.end('mute_delete');

                    // Log to console
                    console.log(error);

                    // Close modal
                    this.$close(true);

                });

            },
        },
    }
</script>